import DashboardLayout from './DashBoard/DashboardLayout';
import './Css/Dashboard.css';

const Dashboard = () => {
  return (
    <DashboardLayout />
  );
};

export default Dashboard;